var rustItems = [
  {
      "short": "weapon.mod.8x.scope",
      "id": "174866732",
      "name": "16x Zoom Scope"
  },
  {
      "short": "bow.compound",
      "id": "884424049",
      "name": "Compound Bow"
  },
  {
      "short": "crossbow",
      "id": "1965232394",
      "name": "Crossbow"
  },
  {
      "short": "knife.bone",
      "id": "1814288539",
      "name": "Bone Knife"
  },
  {
      "short": "smg.2",
      "id": "1796682209",
      "name": "Custom SMG"
  },
  {
      "short": "knife.butcher",
      "id": "-194509282",
      "name": "Butcher Knife"
  },
  {
      "short": "weapon.mod.small.scope",
      "id": "567235583",
      "name": "8x Zoom Scope"
  },
  {
      "short": "grenade.beancan",
      "id": "1840822026",
      "name": "Beancan Grenade"
  },
  {
      "short": "bone.club",
      "id": "1711033574",
      "name": "Bone Club"
  },
  {
      "short": "rifle.bolt",
      "id": "1588298435",
      "name": "Bolt Action Rifle"
  },
  {
      "short": "candycaneclub",
      "id": "1789825282",
      "name": "Candy Cane Club"
  },
  {
      "short": "knife.combat",
      "id": "2040726127",
      "name": "Combat Knife"
  },
  {
      "short": "rifle.ak",
      "id": "1545779598",
      "name": "Assault Rifle"
  },
  {
      "short": "shotgun.double",
      "id": "-765183617",
      "name": "Double Barrel Shotgun"
  },
  {
      "short": "pistol.eoka",
      "id": "-75944661",
      "name": "Eoka Pistol"
  },
  {
      "short": "grenade.f1",
      "id": "143803535",
      "name": "F1 Grenade"
  },
  {
      "short": "flamethrower",
      "id": "-1215753368",
      "name": "Flame Thrower"
  },
  {
      "short": "weapon.mod.holosight",
      "id": "442289265",
      "name": "Holosight"
  },
  {
      "short": "rifle.l96",
      "id": "-778367295",
      "name": "L96 Rifle"
  },
  {
      "short": "bow.hunting",
      "id": "1443579727",
      "name": "Hunting Bow"
  },
  {
      "short": "longsword",
      "id": "-1469578201",
      "name": "Longsword"
  },
  {
      "short": "rifle.lr300",
      "id": "-1812555177",
      "name": "LR-300 Assault Rifle"
  },
  {
      "short": "smg.mp5",
      "id": "1318558775",
      "name": "MP5A4"
  },
  {
      "short": "lmg.m249",
      "id": "-2069578888",
      "name": "M249"
  },
  {
      "short": "pistol.m92",
      "id": "-852563019",
      "name": "M92 Pistol"
  },
  {
      "short": "rifle.m39",
      "id": "28201841",
      "name": "M39 Rifle"
  },
  {
      "short": "machete",
      "id": "-1137865085",
      "name": "Machete"
  },
  {
      "short": "multiplegrenadelauncher",
      "id": "-1123473824",
      "name": "Multiple Grenade Launcher"
  },
  {
      "short": "mace",
      "id": "-1966748496",
      "name": "Mace"
  },
  {
      "short": "pistol.nailgun",
      "id": "1953903201",
      "name": "Nailgun"
  },
  {
      "short": "weapon.mod.muzzleboost",
      "id": "-1405508498",
      "name": "Muzzle Boost"
  },
  {
      "short": "weapon.mod.muzzlebrake",
      "id": "1478091698",
      "name": "Muzzle Brake"
  },
  {
      "short": "shotgun.pump",
      "id": "795371088",
      "name": "Pump Shotgun"
  },
  {
      "short": "paddle",
      "id": "1491189398",
      "name": "Paddle"
  },
  {
      "short": "pitchfork",
      "id": "1090916276",
      "name": "Pitchfork"
  },
  {
      "short": "pistol.python",
      "id": "1373971859",
      "name": "Python Revolver"
  },
  {
      "short": "pistol.revolver",
      "id": "649912614",
      "name": "Revolver"
  },
  {
      "short": "rocket.launcher",
      "id": "442886268",
      "name": "Rocket Launcher"
  },
  {
      "short": "salvaged.cleaver",
      "id": "-1978999529",
      "name": "Salvaged Cleaver"
  },
  {
      "short": "salvaged.sword",
      "id": "1326180354",
      "name": "Salvaged Sword"
  },
  {
      "short": "rifle.semiauto",
      "id": "-904863145",
      "name": "Semi-Automatic Rifle"
  },
  {
      "short": "pistol.semiauto",
      "id": "818877484",
      "name": "Semi-Automatic Pistol"
  },
  {
      "short": "weapon.mod.silencer",
      "id": "-1850571427",
      "name": "Silencer"
  },
  {
      "short": "weapon.mod.simplesight",
      "id": "-855748505",
      "name": "Simple Handmade Sight"
  },
  {
      "short": "snowball",
      "id": "-363689972",
      "name": "Snowball"
  },
  {
      "short": "shotgun.spas12",
      "id": "-41440462",
      "name": "Spas-12 Shotgun"
  },
  {
      "short": "snowballgun",
      "id": "1103488722",
      "name": "Snowball Gun"
  },
  {
      "short": "speargun",
      "id": "-1517740219",
      "name": "Speargun"
  },
  {
      "short": "gun.water",
      "id": "722955039",
      "name": "Water Gun"
  },
  {
      "short": "spear.stone",
      "id": "1602646136",
      "name": "Stone Spear"
  },
  {
      "short": "pistol.water",
      "id": "-1815301988",
      "name": "Water Pistol"
  },
  {
      "short": "smg.thompson",
      "id": "-1758372725",
      "name": "Thompson"
  },
  {
      "short": "shotgun.waterpipe",
      "id": "-1367281941",
      "name": "Waterpipe Shotgun"
  },
  {
      "short": "weapon.mod.lasersight",
      "id": "-132516482",
      "name": "Weapon Lasersight"
  },
  {
      "short": "weapon.mod.flashlight",
      "id": "952603248",
      "name": "Weapon flashlight"
  },
  {
      "short": "spear.wooden",
      "id": "1540934679",
      "name": "Wooden Spear"
  },
  {
      "short": "door.hinged.toptier",
      "id": "1353298668",
      "name": "Armored Door"
  },
  {
      "short": "door.double.hinged.toptier",
      "id": "1221063409",
      "name": "Armored Double Door"
  },
  {
      "short": "barricade.woodwire",
      "id": "1382263453",
      "name": "Barbed Wooden Barricade"
  },
  {
      "short": "building.planner",
      "id": "1525520776",
      "name": "Building Plan"
  },
  {
      "short": "wall.frame.fence.gate",
      "id": "1451568081",
      "name": "Chainlink Fence Gate"
  },
  {
      "short": "wall.frame.fence",
      "id": "-1117626326",
      "name": "Chainlink Fence"
  },
  {
      "short": "lock.code",
      "id": "1159991980",
      "name": "Code Lock"
  },
  {
      "short": "barricade.concrete",
      "id": "-1950721390",
      "name": "Concrete Barricade"
  },
  {
      "short": "door.closer",
      "id": "1409529282",
      "name": "Door Closer"
  },
  {
      "short": "floor.grill",
      "id": "936496778",
      "name": "Floor grill"
  },
  {
      "short": "wall.frame.garagedoor",
      "id": "-148794216",
      "name": "Garage Door"
  },
  {
      "short": "floor.triangle.grill",
      "id": "1983621560",
      "name": "Floor triangle grill"
  },
  {
      "short": "wall.external.high.stone",
      "id": "-967648160",
      "name": "High External Stone Wall"
  },
  {
      "short": "gates.external.high.stone",
      "id": "-691113464",
      "name": "High External Stone Gate"
  },
  {
      "short": "wall.external.high",
      "id": "99588025",
      "name": "High External Wooden Wall"
  },
  {
      "short": "gates.external.high.wood",
      "id": "-335089230",
      "name": "High External Wooden Gate"
  },
  {
      "short": "wall.external.high.ice",
      "id": "-985781766",
      "name": "High Ice Wall"
  },
  {
      "short": "lock.key",
      "id": "-850982208",
      "name": "Key Lock"
  },
  {
      "short": "floor.ladder.hatch",
      "id": "1948067030",
      "name": "Ladder Hatch"
  },
  {
      "short": "water.catcher.large",
      "id": "-1100168350",
      "name": "Large Water Catcher"
  },
  {
      "short": "barricade.metal",
      "id": "1655650836",
      "name": "Metal Barricade"
  },
  {
      "short": "wall.frame.shopfront.metal",
      "id": "-148229307",
      "name": "Metal Shop Front"
  },
  {
      "short": "shutter.metal.embrasure.b",
      "id": "-1199897172",
      "name": "Metal Vertical embrasure"
  },
  {
      "short": "wall.window.bars.metal",
      "id": "-819720157",
      "name": "Metal Window Bars"
  },
  {
      "short": "shutter.metal.embrasure.a",
      "id": "-1199897169",
      "name": "Metal horizontal embrasure"
  },
  {
      "short": "wall.frame.netting",
      "id": "1516985844",
      "name": "Netting"
  },
  {
      "short": "mining.quarry",
      "id": "1052926200",
      "name": "Mining Quarry"
  },
  {
      "short": "wall.frame.cell.gate",
      "id": "-956706906",
      "name": "Prison Cell Gate"
  },
  {
      "short": "wall.frame.cell",
      "id": "-1429456799",
      "name": "Prison Cell Wall"
  },
  {
      "short": "mining.pumpjack",
      "id": "-1130709577",
      "name": "Pump Jack"
  },
  {
      "short": "wall.window.bars.toptier",
      "id": "671706427",
      "name": "Reinforced Glass Window"
  },
  {
      "short": "barricade.sandbags",
      "id": "-559599960",
      "name": "Sandbag Barricade"
  },
  {
      "short": "door.hinged.metal",
      "id": "-2067472972",
      "name": "Sheet Metal Door"
  },
  {
      "short": "door.double.hinged.metal",
      "id": "1390353317",
      "name": "Sheet Metal Double Door"
  },
  {
      "short": "wall.frame.shopfront",
      "id": "-796583652",
      "name": "Shop Front"
  },
  {
      "short": "wall.ice.wall",
      "id": "1327005675",
      "name": "Short Ice Wall"
  },
  {
      "short": "water.catcher.small",
      "id": "-132247350",
      "name": "Small Water Catcher"
  },
  {
      "short": "barricade.stone",
      "id": "15388698",
      "name": "Stone Barricade"
  },
  {
      "short": "wall.window.glass.reinforced",
      "id": "-1614955425",
      "name": "Strengthened Glass Window"
  },
  {
      "short": "floor.triangle.ladder.hatch",
      "id": "2041899972",
      "name": "Triangle Ladder Hatch"
  },
  {
      "short": "cupboard.tool",
      "id": "-97956382",
      "name": "Tool Cupboard"
  },
  {
      "short": "watchtower.wood",
      "id": "-463122489",
      "name": "Watch Tower"
  },
  {
      "short": "door.double.hinged.wood",
      "id": "-1336109173",
      "name": "Wood Double Door"
  },
  {
      "short": "shutter.wood.a",
      "id": "-1023374709",
      "name": "Wood Shutters"
  },
  {
      "short": "barricade.wood",
      "id": "866889860",
      "name": "Wooden Barricade"
  },
  {
      "short": "barricade.wood.cover",
      "id": "1373240771",
      "name": "Wooden Barricade Cover"
  },
  {
      "short": "wall.window.bars.wood",
      "id": "-1183726687",
      "name": "Wooden Window Bars"
  },
  {
      "short": "door.hinged.wood",
      "id": "1729120840",
      "name": "Wooden Door"
  },
  {
      "short": "bbq",
      "id": "1099314009",
      "name": "Barbeque"
  },
  {
      "short": "ladder.wooden.wall",
      "id": "-316250604",
      "name": "Wooden Ladder"
  },
  {
      "short": "botabag",
      "id": "613961768",
      "name": "Bota Bag"
  },
  {
      "short": "bed",
      "id": "-1273339005",
      "name": "Bed"
  },
  {
      "short": "cardtable",
      "id": "1081921512",
      "name": "Card Table"
  },
  {
      "short": "campfire",
      "id": "1946219319",
      "name": "Camp Fire"
  },
  {
      "short": "carvable.pumpkin",
      "id": "1524980732",
      "name": "Carvable Pumpkin"
  },
  {
      "short": "chair",
      "id": "1534542921",
      "name": "Chair"
  },
  {
      "short": "chineselantern",
      "id": "-1916473915",
      "name": "Chinese Lantern"
  },
  {
      "short": "arcade.machine.chippy",
      "id": "359723196",
      "name": "Chippy Arcade Game"
  },
  {
      "short": "xmasdoorwreath",
      "id": "2009734114",
      "name": "Christmas Door Wreath"
  },
  {
      "short": "composter",
      "id": "-1488398114",
      "name": "Composter"
  },
  {
      "short": "xmas.lightstring",
      "id": "1058261682",
      "name": "Christmas Lights"
  },
  {
      "short": "xmas.tree",
      "id": "794443127",
      "name": "Christmas Tree"
  },
  {
      "short": "sign.post.double",
      "id": "1521286012",
      "name": "Double Sign Post"
  },
  {
      "short": "dropbox",
      "id": "-1519126340",
      "name": "Drop Box"
  },
  {
      "short": "dragondoorknocker",
      "id": "-854270928",
      "name": "Dragon Door Knocker"
  },
  {
      "short": "easterdoorwreath",
      "id": "-979302481",
      "name": "Easter Door Wreath"
  },
  {
      "short": "xmas.door.garland",
      "id": "674734128",
      "name": "Festive Doorway Garland"
  },
  {
      "short": "xmas.window.garland",
      "id": "-1379835144",
      "name": "Festive Window Garland"
  },
  {
      "short": "fridge",
      "id": "1413014235",
      "name": "Fridge"
  },
  {
      "short": "furnace",
      "id": "-1999722522",
      "name": "Furnace"
  },
  {
      "short": "frankensteintable",
      "id": "1575635062",
      "name": "Frankenstein Table"
  },
  {
      "short": "hobobarrel",
      "id": "-1442559428",
      "name": "Hobo Barrel"
  },
  {
      "short": "hitchtroughcombo",
      "id": "1160881421",
      "name": "Hitch & Trough"
  },
  {
      "short": "sign.wooden.huge",
      "id": "-143132326",
      "name": "Huge Wooden Sign"
  },
  {
      "short": "jackolantern.angry",
      "id": "1242482355",
      "name": "Jack O Lantern Angry"
  },
  {
      "short": "kayak",
      "id": "190184021",
      "name": "Kayak"
  },
  {
      "short": "jackolantern.happy",
      "id": "-1824943010",
      "name": "Jack O Lantern Happy"
  },
  {
      "short": "photoframe.landscape",
      "id": "1697996440",
      "name": "Landscape Photo Frame"
  },
  {
      "short": "lantern",
      "id": "1658229558",
      "name": "Lantern"
  },
  {
      "short": "sign.pictureframe.landscape",
      "id": "-845557339",
      "name": "Landscape Picture Frame"
  },
  {
      "short": "sign.hanging.banner.large",
      "id": "23352662",
      "name": "Large Banner Hanging"
  },
  {
      "short": "sign.pole.banner.large",
      "id": "2070189026",
      "name": "Large Banner on pole"
  },
  {
      "short": "furnace.large",
      "id": "-1992717673",
      "name": "Large Furnace"
  },
  {
      "short": "planter.large",
      "id": "1581210395",
      "name": "Large Planter Box"
  },
  {
      "short": "sign.wooden.large",
      "id": "1153652756",
      "name": "Large Wooden Sign"
  },
  {
      "short": "photoframe.large",
      "id": "1205084994",
      "name": "Large Photo Frame"
  },
  {
      "short": "locker",
      "id": "-110921842",
      "name": "Locker"
  },
  {
      "short": "box.wooden.large",
      "id": "833533164",
      "name": "Large Wood Box"
  },
  {
      "short": "mailbox",
      "id": "-586784898",
      "name": "Mail Box"
  },
  {
      "short": "mixingtable",
      "id": "1259919256",
      "name": "Mixing Table"
  },
  {
      "short": "sign.wooden.medium",
      "id": "-1819233322",
      "name": "Medium Wooden Sign"
  },
  {
      "short": "map",
      "id": "696029452",
      "name": "Paper Map"
  },
  {
      "short": "sign.post.town",
      "id": "-1832422579",
      "name": "One Sided Town Sign Post"
  },
  {
      "short": "pookie.bear",
      "id": "-1651220691",
      "name": "Pookie Bear"
  },
  {
      "short": "photoframe.portrait",
      "id": "1729712564",
      "name": "Portrait Photo Frame"
  },
  {
      "short": "sign.pictureframe.portrait",
      "id": "-1370759135",
      "name": "Portrait Picture Frame"
  },
  {
      "short": "box.repair.bench",
      "id": "803222026",
      "name": "Repair Bench"
  },
  {
      "short": "research.table",
      "id": "-1861522751",
      "name": "Research Table"
  },
  {
      "short": "rug",
      "id": "-1985799200",
      "name": "Rug"
  },
  {
      "short": "rug.bear",
      "id": "-1104881824",
      "name": "Rug Bear Skin"
  },
  {
      "short": "stocking.large",
      "id": "-465682601",
      "name": "SUPER Stocking"
  },
  {
      "short": "shelves",
      "id": "1950721418",
      "name": "Salvaged Shelves"
  },
  {
      "short": "scarecrow",
      "id": "177226991",
      "name": "Scarecrow"
  },
  {
      "short": "secretlabchair",
      "id": "567871954",
      "name": "Secret Lab Chair"
  },
  {
      "short": "skulldoorknocker",
      "id": "-216116642",
      "name": "Skull Door Knocker"
  },
  {
      "short": "sign.post.single",
      "id": "1542290441",
      "name": "Single Sign Post"
  },
  {
      "short": "sleepingbag",
      "id": "-1754948969",
      "name": "Sleeping Bag"
  },
  {
      "short": "pit",
      "id": "553887414",
      "name": "Skull Fire Pit"
  },
  {
      "short": "small.oil.refinery",
      "id": "-1293296287",
      "name": "Small Oil Refinery"
  },
  {
      "short": "stash.small",
      "id": "-369760990",
      "name": "Small Stash"
  },
  {
      "short": "stocking.small",
      "id": "1668858301",
      "name": "Small Stocking"
  },
  {
      "short": "planter.small",
      "id": "1903654061",
      "name": "Small Planter Box"
  },
  {
      "short": "snowman",
      "id": "1629293099",
      "name": "Snowman"
  },
  {
      "short": "sofa",
      "id": "-555122905",
      "name": "Sofa"
  },
  {
      "short": "sign.wooden.small",
      "id": "-1138208076",
      "name": "Small Wooden Sign"
  },
  {
      "short": "spinner.wheel",
      "id": "-1100422738",
      "name": "Spinning wheel"
  },
  {
      "short": "fireplace.stone",
      "id": "-1535621066",
      "name": "Stone Fireplace"
  },
  {
      "short": "sofa.pattern",
      "id": "782422285",
      "name": "Sofa - Pattern"
  },
  {
      "short": "fishtrap.small",
      "id": "559147458",
      "name": "Survival Fish Trap"
  },
  {
      "short": "table",
      "id": "593465182",
      "name": "Table"
  },
  {
      "short": "sign.pictureframe.tall",
      "id": "121049755",
      "name": "Tall Picture Frame"
  },
  {
      "short": "water.barrel",
      "id": "-1863559151",
      "name": "Water Barrel"
  },
  {
      "short": "tunalight",
      "id": "-1478445584",
      "name": "Tuna Can Lamp"
  },
  {
      "short": "sign.hanging",
      "id": "1205607945",
      "name": "Two Sided Hanging Sign"
  },
  {
      "short": "vending.machine",
      "id": "198438816",
      "name": "Vending Machine"
  },
  {
      "short": "sign.hanging.ornate",
      "id": "-1647846966",
      "name": "Two Sided Ornate Hanging Sign"
  },
  {
      "short": "sign.post.town.roof",
      "id": "826309791",
      "name": "Two Sided Town Sign Post"
  },
  {
      "short": "water.purifier",
      "id": "2114754781",
      "name": "Water Purifier"
  },
  {
      "short": "box.wooden",
      "id": "-180129657",
      "name": "Wood Storage Box"
  },
  {
      "short": "workbench1",
      "id": "1524187186",
      "name": "Workbench Level 1"
  },
  {
      "short": "workbench2",
      "id": "-41896755",
      "name": "Workbench Level 2"
  },
  {
      "short": "sign.pictureframe.xl",
      "id": "-996185386",
      "name": "XL Picture Frame"
  },
  {
      "short": "sign.pictureframe.xxl",
      "id": "98508942",
      "name": "XXL Picture Frame"
  },
  {
      "short": "workbench3",
      "id": "-1607980696",
      "name": "Workbench Level 3"
  },
  {
      "short": "fat.animal",
      "id": "-1018587433",
      "name": "Animal Fat"
  },
  {
      "short": "battery.small",
      "id": "609049394",
      "name": "Battery - Small"
  },
  {
      "short": "cctv.camera",
      "id": "634478325",
      "name": "CCTV Camera"
  },
  {
      "short": "bone.fragments",
      "id": "1719978075",
      "name": "Bone Fragments"
  },
  {
      "short": "charcoal",
      "id": "-1938052175",
      "name": "Charcoal"
  },
  {
      "short": "cloth",
      "id": "-858312878",
      "name": "Cloth"
  },
  {
      "short": "coal",
      "id": "204391461",
      "name": "Coal :("
  },
  {
      "short": "crude.oil",
      "id": "-321733511",
      "name": "Crude Oil"
  },
  {
      "short": "barrel",
      "id": "1568388703",
      "name": "Diesel Fuel"
  },
  {
      "short": "explosives",
      "id": "-592016202",
      "name": "Explosives"
  },
  {
      "short": "can.beans.empty",
      "id": "1655979682",
      "name": "Empty Can Of Beans"
  },
  {
      "short": "gunpowder",
      "id": "-265876753",
      "name": "Gun Powder"
  },
  {
      "short": "fertilizer",
      "id": "-930193596",
      "name": "Fertilizer"
  },
  {
      "short": "can.tuna.empty",
      "id": "-1557377697",
      "name": "Empty Tuna Can"
  },
  {
      "short": "metal.refined",
      "id": "317398316",
      "name": "High Quality Metal"
  },
  {
      "short": "hq.metal.ore",
      "id": "-1982036270",
      "name": "High Quality Metal Ore"
  },
  {
      "short": "horsedung",
      "id": "-1579932985",
      "name": "Horse Dung"
  },
  {
      "short": "leather",
      "id": "1381010055",
      "name": "Leather"
  },
  {
      "short": "skull.human",
      "id": "996293980",
      "name": "Human Skull"
  },
  {
      "short": "lowgradefuel",
      "id": "-946369541",
      "name": "Low Grade Fuel"
  },
  {
      "short": "researchpaper",
      "id": "-544317637",
      "name": "Research Paper"
  },
  {
      "short": "metal.fragments",
      "id": "69511070",
      "name": "Metal Fragments"
  },
  {
      "short": "metal.ore",
      "id": "-4031221",
      "name": "Metal Ore"
  },
  {
      "short": "water.salt",
      "id": "-277057363",
      "name": "Salt Water"
  },
  {
      "short": "paper",
      "id": "-1779183908",
      "name": "Paper"
  },
  {
      "short": "plantfiber",
      "id": "-804769727",
      "name": "Plant Fiber"
  },
  {
      "short": "scrap",
      "id": "-932201673",
      "name": "Scrap"
  },
  {
      "short": "stones",
      "id": "-2099697608",
      "name": "Stones"
  },
  {
      "short": "sulfur",
      "id": "-1581843485",
      "name": "Sulfur"
  },
  {
      "short": "sulfur.ore",
      "id": "-1157596551",
      "name": "Sulfur Ore"
  },
  {
      "short": "targeting.computer",
      "id": "1523195708",
      "name": "Targeting Computer"
  },
  {
      "short": "water",
      "id": "-1779180711",
      "name": "Water"
  },
  {
      "short": "skull.wolf",
      "id": "2048317869",
      "name": "Wolf Skull"
  },
  {
      "short": "attire.banditguard",
      "id": "-1622110948",
      "name": "Bandit Guard Gear"
  },
  {
      "short": "mask.bandana",
      "id": "-702051347",
      "name": "Bandana Mask"
  },
  {
      "short": "barrelcostume",
      "id": "-1215166612",
      "name": "A Barrel Costume"
  },
  {
      "short": "wood",
      "id": "-151838493",
      "name": "Wood"
  },
  {
      "short": "hat.cap",
      "id": "-1022661119",
      "name": "Baseball Cap"
  },
  {
      "short": "hat.beenie",
      "id": "1675639563",
      "name": "Beenie Hat"
  },
  {
      "short": "horse.shoes.basic",
      "id": "-1211268013",
      "name": "Basic Horse Shoes"
  },
  {
      "short": "jumpsuit.suit.blue",
      "id": "1601468620",
      "name": "Blue Jumpsuit"
  },
  {
      "short": "bone.armor.suit",
      "id": "1746956556",
      "name": "Bone Armor"
  },
  {
      "short": "deer.skull.mask",
      "id": "-1903165497",
      "name": "Bone Helmet"
  },
  {
      "short": "hat.boonie",
      "id": "-23994173",
      "name": "Boonie Hat"
  },
  {
      "short": "shoes.boots",
      "id": "-1549739227",
      "name": "Boots"
  },
  {
      "short": "attire.bunnyears",
      "id": "-1004426654",
      "name": "Bunny Ears"
  },
  {
      "short": "bucket.helmet",
      "id": "850280505",
      "name": "Bucket Helmet"
  },
  {
      "short": "hat.bunnyhat",
      "id": "23391694",
      "name": "Bunny Hat"
  },
  {
      "short": "attire.bunny.onesie",
      "id": "-1266045928",
      "name": "Bunny Onesie"
  },
  {
      "short": "burlap.gloves.new",
      "id": "21402876",
      "name": "Burlap Gloves"
  },
  {
      "short": "burlap.headwrap",
      "id": "1877339384",
      "name": "Burlap Headwrap"
  },
  {
      "short": "burlap.shirt",
      "id": "602741290",
      "name": "Burlap Shirt"
  },
  {
      "short": "burlap.shoes",
      "id": "-761829530",
      "name": "Burlap Shoes"
  },
  {
      "short": "burlap.trousers",
      "id": "1992974553",
      "name": "Burlap Trousers"
  },
  {
      "short": "hat.candle",
      "id": "1714496074",
      "name": "Candle Hat"
  },
  {
      "short": "coffeecan.helmet",
      "id": "-803263829",
      "name": "Coffee Can Helmet"
  },
  {
      "short": "clatter.helmet",
      "id": "968019378",
      "name": "Clatter Helmet"
  },
  {
      "short": "movembermoustachecard",
      "id": "3380160",
      "name": "Card Movember Moustache"
  },
  {
      "short": "cratecostume",
      "id": "1189981699",
      "name": "Crate Costume"
  },
  {
      "short": "diving.mask",
      "id": "-113413047",
      "name": "Diving Mask"
  },
  {
      "short": "diving.fins",
      "id": "296519935",
      "name": "Diving Fins"
  },
  {
      "short": "diving.tank",
      "id": "-2022172587",
      "name": "Diving Tank"
  },
  {
      "short": "boots.frog",
      "id": "-1000573653",
      "name": "Frog Boots"
  },
  {
      "short": "hat.dragonmask",
      "id": "-22883916",
      "name": "Dragon Mask"
  },
  {
      "short": "hat.gas.mask",
      "id": "1659114910",
      "name": "Gas Mask"
  },
  {
      "short": "ghostsheet",
      "id": "-1043618880",
      "name": "Ghost Costume"
  },
  {
      "short": "gloweyes",
      "id": "-690276911",
      "name": "Glowing Eyes"
  },
  {
      "short": "hazmatsuit",
      "id": "1266491000",
      "name": "Hazmat Suit"
  },
  {
      "short": "frankensteins.monster.03.head",
      "id": "-297099594",
      "name": "Heavy Frankenstein Head"
  },
  {
      "short": "twitch.headset",
      "id": "-1569700847",
      "name": "Headset"
  },
  {
      "short": "frankensteins.monster.03.legs",
      "id": "-2024549027",
      "name": "Heavy Frankenstein Legs"
  },
  {
      "short": "frankensteins.monster.03.torso",
      "id": "1614528785",
      "name": "Heavy Frankenstein Torso"
  },
  {
      "short": "heavy.plate.helmet",
      "id": "1181207482",
      "name": "Heavy Plate Helmet"
  },
  {
      "short": "heavy.plate.jacket",
      "id": "-1102429027",
      "name": "Heavy Plate Jacket"
  },
  {
      "short": "heavy.plate.pants",
      "id": "-1778159885",
      "name": "Heavy Plate Pants"
  },
  {
      "short": "attire.hide.boots",
      "id": "794356786",
      "name": "Hide Boots"
  },
  {
      "short": "heavy",
      "id": "-1772746857",
      "name": "Heavy Scientist Suit"
  },
  {
      "short": "attire.hide.pants",
      "id": "1722154847",
      "name": "Hide Pants"
  },
  {
      "short": "attire.hide.helterneck",
      "id": "3222790",
      "name": "Hide Halterneck"
  },
  {
      "short": "attire.hide.poncho",
      "id": "980333378",
      "name": "Hide Poncho"
  },
  {
      "short": "attire.hide.vest",
      "id": "196700171",
      "name": "Hide Vest"
  },
  {
      "short": "horse.shoes.advanced",
      "id": "1989785143",
      "name": "High Quality Horse Shoes"
  },
  {
      "short": "attire.hide.skirt",
      "id": "-1773144852",
      "name": "Hide Skirt"
  },
  {
      "short": "hoodie",
      "id": "1751045826",
      "name": "Hoodie"
  },
  {
      "short": "mask.balaclava",
      "id": "-2012470695",
      "name": "Improvised Balaclava"
  },
  {
      "short": "jacket",
      "id": "-1163532624",
      "name": "Jacket"
  },
  {
      "short": "jumpsuit.suit",
      "id": "-97459906",
      "name": "Jumpsuit"
  },
  {
      "short": "horse.saddle",
      "id": "-1997543660",
      "name": "Horse Saddle"
  },
  {
      "short": "frankensteins.monster.01.head",
      "id": "-134959124",
      "name": "Light Frankenstein Head"
  },
  {
      "short": "burlap.gloves",
      "id": "1366282552",
      "name": "Leather Gloves"
  },
  {
      "short": "frankensteins.monster.01.legs",
      "id": "106959911",
      "name": "Light Frankenstein Legs"
  },
  {
      "short": "frankensteins.monster.01.torso",
      "id": "-1624770297",
      "name": "Light Frankenstein Torso"
  },
  {
      "short": "tshirt.long",
      "id": "935692442",
      "name": "Longsleeve T-Shirt"
  },
  {
      "short": "20hoodie",
      "id": "-763071910",
      "name": "Lumberjack Hoodie"
  },
  {
      "short": "frankensteins.monster.02.head",
      "id": "-1732475823",
      "name": "Medium Frankenstein Head"
  },
  {
      "short": "frankensteins.monster.02.legs",
      "id": "835042040",
      "name": "Medium Frankenstein Legs"
  },
  {
      "short": "metal.facemask",
      "id": "-194953424",
      "name": "Metal Facemask"
  },
  {
      "short": "frankensteins.monster.02.torso",
      "id": "1491753484",
      "name": "Medium Frankenstein Torso"
  },
  {
      "short": "metal.plate.torso",
      "id": "1110385766",
      "name": "Metal Chest Plate"
  },
  {
      "short": "hat.miner",
      "id": "-1539025626",
      "name": "Miners Hat"
  },
  {
      "short": "movembermoustache",
      "id": "-2047081330",
      "name": "Movember Moustache"
  },
  {
      "short": "halloween.mummysuit",
      "id": "277730763",
      "name": "Mummy Suit"
  },
  {
      "short": "attire.nesthat",
      "id": "1081315464",
      "name": "Nest Hat"
  },
  {
      "short": "nightvisiongoggles",
      "id": "-1518883088",
      "name": "Night Vision Goggles"
  },
  {
      "short": "attire.ninja.suit",
      "id": "-1506417026",
      "name": "Ninja Suit"
  },
  {
      "short": "hat.oxmask",
      "id": "1315082560",
      "name": "Ox Mask"
  },
  {
      "short": "pants",
      "id": "237239288",
      "name": "Pants"
  },
  {
      "short": "partyhat",
      "id": "-575744869",
      "name": "Party Hat"
  },
  {
      "short": "twitchsunglasses",
      "id": "20489901",
      "name": "Purple Sunglasses"
  },
  {
      "short": "hat.ratmask",
      "id": "271048478",
      "name": "Rat Mask"
  },
  {
      "short": "attire.reindeer.headband",
      "id": "-324675402",
      "name": "Reindeer Antlers"
  },
  {
      "short": "riot.helmet",
      "id": "671063303",
      "name": "Riot Helmet"
  },
  {
      "short": "roadsign.kilt",
      "id": "1850456855",
      "name": "Road Sign Kilt"
  },
  {
      "short": "roadsign.jacket",
      "id": "-2002277461",
      "name": "Road Sign Jacket"
  },
  {
      "short": "roadsign.gloves",
      "id": "-699558439",
      "name": "Roadsign Gloves"
  },
  {
      "short": "horse.armor.roadsign",
      "id": "60528587",
      "name": "Roadsign Horse Armor"
  },
  {
      "short": "horse.saddlebag",
      "id": "1400460850",
      "name": "Saddle bag"
  },
  {
      "short": "santabeard",
      "id": "2126889441",
      "name": "Santa Beard"
  },
  {
      "short": "santahat",
      "id": "-575483084",
      "name": "Santa Hat"
  },
  {
      "short": "scarecrowhead",
      "id": "809942731",
      "name": "Scarecrow Wrap"
  },
  {
      "short": "scarecrow.suit",
      "id": "273951840",
      "name": "Scarecrow Suit"
  },
  {
      "short": "peacekeeper",
      "id": "-253079493",
      "name": "Scientist Suit"
  },
  {
      "short": "shirt.collared",
      "id": "-2025184684",
      "name": "Shirt"
  },
  {
      "short": "pants.shorts",
      "id": "-1695367501",
      "name": "Shorts"
  },
  {
      "short": "jacket.snow",
      "id": "-48090175",
      "name": "Snow Jacket"
  },
  {
      "short": "sunglasses",
      "id": "352321488",
      "name": "Sunglasses"
  },
  {
      "short": "halloween.surgeonsuit",
      "id": "-1785231475",
      "name": "Surgeon Scrubs"
  },
  {
      "short": "tshirt",
      "id": "223891266",
      "name": "T-Shirt"
  },
  {
      "short": "tactical.gloves",
      "id": "-1108136649",
      "name": "Tactical Gloves"
  },
  {
      "short": "shirt.tanktop",
      "id": "1608640313",
      "name": "Tank Top"
  },
  {
      "short": "diving.wetsuit",
      "id": "-1101924344",
      "name": "Wetsuit"
  },
  {
      "short": "wood.armor.helmet",
      "id": "-2094954543",
      "name": "Wood Armor Helmet"
  },
  {
      "short": "hat.wolf",
      "id": "-1478212975",
      "name": "Wolf Headdress"
  },
  {
      "short": "wood.armor.pants",
      "id": "832133926",
      "name": "Wood Armor Pants"
  },
  {
      "short": "wood.armor.jacket",
      "id": "418081930",
      "name": "Wood Chestplate"
  },
  {
      "short": "horse.armor.wood",
      "id": "1659447559",
      "name": "Wooden Horse Armor"
  },
  {
      "short": "tool.binoculars",
      "id": "-1262185308",
      "name": "Binoculars"
  },
  {
      "short": "cakefiveyear",
      "id": "1973165031",
      "name": "Birthday Cake"
  },
  {
      "short": "tool.camera",
      "id": "-1316706473",
      "name": "Camera"
  },
  {
      "short": "chainsaw",
      "id": "1104520648",
      "name": "Chainsaw"
  },
  {
      "short": "fishing.tackle",
      "id": "-1707425764",
      "name": "Fishing Tackle"
  },
  {
      "short": "flare",
      "id": "304481038",
      "name": "Flare"
  },
  {
      "short": "toolgun",
      "id": "1803831286",
      "name": "Garry's Mod Tool Gun"
  },
  {
      "short": "flashlight.held",
      "id": "-196667575",
      "name": "Flashlight"
  },
  {
      "short": "hammer",
      "id": "200773292",
      "name": "Hammer"
  },
  {
      "short": "geiger.counter",
      "id": "999690781",
      "name": "Geiger Counter"
  },
  {
      "short": "fishingrod.handmade",
      "id": "1569882109",
      "name": "Handmade Fishing Rod"
  },
  {
      "short": "hatchet",
      "id": "-1252059217",
      "name": "Hatchet"
  },
  {
      "short": "camera",
      "id": "-2001260025",
      "name": "Instant Camera"
  },
  {
      "short": "jackhammer",
      "id": "1488979457",
      "name": "Jackhammer"
  },
  {
      "short": "pickaxe",
      "id": "-1302129395",
      "name": "Pickaxe"
  },
  {
      "short": "rf.detonator",
      "id": "596469572",
      "name": "RF Transmitter"
  },
  {
      "short": "rock",
      "id": "963906841",
      "name": "Rock"
  },
  {
      "short": "axe.salvaged",
      "id": "-262590403",
      "name": "Salvaged Axe"
  },
  {
      "short": "explosive.satchel",
      "id": "-1878475007",
      "name": "Satchel Charge"
  },
  {
      "short": "icepick.salvaged",
      "id": "-1780802565",
      "name": "Salvaged Icepick"
  },
  {
      "short": "hammer.salvaged",
      "id": "-1506397857",
      "name": "Salvaged Hammer"
  },
  {
      "short": "grenade.smoke",
      "id": "1263920163",
      "name": "Smoke Grenade"
  },
  {
      "short": "stonehatchet",
      "id": "-1583967946",
      "name": "Stone Hatchet"
  },
  {
      "short": "stone.pickaxe",
      "id": "171931394",
      "name": "Stone Pickaxe"
  },
  {
      "short": "surveycharge",
      "id": "1975934948",
      "name": "Survey Charge"
  },
  {
      "short": "supply.signal",
      "id": "1397052267",
      "name": "Supply Signal"
  },
  {
      "short": "torch",
      "id": "795236088",
      "name": "Torch"
  },
  {
      "short": "explosive.timed",
      "id": "1248356124",
      "name": "Timed Explosive Charge"
  },
  {
      "short": "bucket.water",
      "id": "1424075905",
      "name": "Water Bucket"
  },
  {
      "short": "antiradpills",
      "id": "-1432674913",
      "name": "Anti-Radiation Pills"
  },
  {
      "short": "blood",
      "id": "1776460938",
      "name": "Blood"
  },
  {
      "short": "bandage",
      "id": "-2072273936",
      "name": "Bandage"
  },
  {
      "short": "largemedkit",
      "id": "254522515",
      "name": "Large Medkit"
  },
  {
      "short": "syringe.medical",
      "id": "1079279582",
      "name": "Medical Syringe"
  },
  {
      "short": "radiationresisttea.advanced",
      "id": "-1729415579",
      "name": "Adv. Anti-Rad Tea"
  },
  {
      "short": "healingtea.advanced",
      "id": "-2123125470",
      "name": "Advanced Healing Tea"
  },
  {
      "short": "maxhealthtea.advanced",
      "id": "603811464",
      "name": "Advanced Max Health Tea"
  },
  {
      "short": "oretea.advanced",
      "id": "2063916636",
      "name": "Advanced Ore Tea"
  },
  {
      "short": "scraptea.advanced",
      "id": "524678627",
      "name": "Advanced Scrap Tea"
  },
  {
      "short": "radiationremovetea.advanced",
      "id": "2021351233",
      "name": "Advanced Rad. Removal Tea"
  },
  {
      "short": "woodtea.advanced",
      "id": "-541206665",
      "name": "Advanced Wood Tea"
  },
  {
      "short": "apple",
      "id": "1548091822",
      "name": "Apple"
  },
  {
      "short": "fish.anchovy",
      "id": "342438846",
      "name": "Anchovy"
  },
  {
      "short": "radiationresisttea",
      "id": "-487356515",
      "name": "Anti-Rad Tea"
  },
  {
      "short": "healingtea",
      "id": "-929092070",
      "name": "Basic Healing Tea"
  },
  {
      "short": "maxhealthtea",
      "id": "-1184406448",
      "name": "Basic Max Health Tea"
  },
  {
      "short": "oretea",
      "id": "1480022580",
      "name": "Basic Ore Tea"
  },
  {
      "short": "scraptea",
      "id": "263834859",
      "name": "Basic Scrap Tea"
  },
  {
      "short": "woodtea",
      "id": "-649128577",
      "name": "Basic Wood Tea"
  },
  {
      "short": "black.berry",
      "id": "1771755747",
      "name": "Black Berry"
  },
  {
      "short": "clone.black.berry",
      "id": "122783240",
      "name": "Black Berry Clone"
  },
  {
      "short": "black.raspberries",
      "id": "1931713481",
      "name": "Black Raspberries"
  },
  {
      "short": "blue.berry",
      "id": "1112162468",
      "name": "Blue Berry"
  },
  {
      "short": "seed.black.berry",
      "id": "1911552868",
      "name": "Black Berry Seed"
  },
  {
      "short": "clone.blue.berry",
      "id": "838831151",
      "name": "Blue Berry Clone"
  },
  {
      "short": "blueberries",
      "id": "-586342290",
      "name": "Blueberries"
  },
  {
      "short": "seed.blue.berry",
      "id": "803954639",
      "name": "Blue Berry Seed"
  },
  {
      "short": "bearmeat.burned",
      "id": "-989755543",
      "name": "Burnt Bear Meat"
  },
  {
      "short": "chicken.burned",
      "id": "1973684065",
      "name": "Burnt Chicken"
  },
  {
      "short": "deermeat.burned",
      "id": "-78533081",
      "name": "Burnt Deer Meat"
  },
  {
      "short": "horsemeat.burned",
      "id": "1917703890",
      "name": "Burnt Horse Meat"
  },
  {
      "short": "wolfmeat.burned",
      "id": "1827479659",
      "name": "Burnt Wolf Meat"
  },
  {
      "short": "humanmeat.burned",
      "id": "-682687162",
      "name": "Burnt Human Meat"
  },
  {
      "short": "meat.pork.burned",
      "id": "1391703481",
      "name": "Burnt Pork"
  },
  {
      "short": "can.beans",
      "id": "-700591459",
      "name": "Can of Beans"
  },
  {
      "short": "cactusflesh",
      "id": "1783512007",
      "name": "Cactus Flesh"
  },
  {
      "short": "can.tuna",
      "id": "-1941646328",
      "name": "Can of Tuna"
  },
  {
      "short": "fish.catfish",
      "id": "-587989372",
      "name": "Catfish"
  },
  {
      "short": "candycane",
      "id": "1121925526",
      "name": "Candy Cane"
  },
  {
      "short": "chocholate",
      "id": "363467698",
      "name": "Chocolate Bar"
  },
  {
      "short": "bearmeat.cooked",
      "id": "1873897110",
      "name": "Cooked Bear Meat"
  },
  {
      "short": "fish.cooked",
      "id": "1668129151",
      "name": "Cooked Fish"
  },
  {
      "short": "chicken.cooked",
      "id": "-1848736516",
      "name": "Cooked Chicken"
  },
  {
      "short": "deermeat.cooked",
      "id": "-1509851560",
      "name": "Cooked Deer Meat"
  },
  {
      "short": "humanmeat.cooked",
      "id": "1536610005",
      "name": "Cooked Human Meat"
  },
  {
      "short": "horsemeat.cooked",
      "id": "-1162759543",
      "name": "Cooked Horse Meat"
  },
  {
      "short": "meat.pork.cooked",
      "id": "-242084766",
      "name": "Cooked Pork"
  },
  {
      "short": "wolfmeat.cooked",
      "id": "813023040",
      "name": "Cooked Wolf Meat"
  },
  {
      "short": "clone.corn",
      "id": "-778875547",
      "name": "Corn Clone"
  },
  {
      "short": "corn",
      "id": "1367190888",
      "name": "Corn"
  },
  {
      "short": "green.berry",
      "id": "858486327",
      "name": "Green Berry"
  },
  {
      "short": "seed.corn",
      "id": "998894949",
      "name": "Corn Seed"
  },
  {
      "short": "granolabar",
      "id": "-746030907",
      "name": "Granola Bar"
  },
  {
      "short": "seed.green.berry",
      "id": "-1776128552",
      "name": "Green Berry Seed"
  },
  {
      "short": "clone.green.berry",
      "id": "-1305326964",
      "name": "Green Berry Clone"
  },
  {
      "short": "grub",
      "id": "-568419968",
      "name": "Grub"
  },
  {
      "short": "clone.hemp",
      "id": "-886280491",
      "name": "Hemp Clone"
  },
  {
      "short": "fish.herring",
      "id": "-1698937385",
      "name": "Herring"
  },
  {
      "short": "seed.hemp",
      "id": "-237809779",
      "name": "Hemp Seed"
  },
  {
      "short": "fish.minnows",
      "id": "-542577259",
      "name": "Minnows"
  },
  {
      "short": "mushroom",
      "id": "-1962971928",
      "name": "Mushroom"
  },
  {
      "short": "fish.orangeroughy",
      "id": "-1904821376",
      "name": "Orange Roughy"
  },
  {
      "short": "jar.pickle",
      "id": "286193827",
      "name": "Pickles"
  },
  {
      "short": "potato",
      "id": "-2086926071",
      "name": "Potato"
  },
  {
      "short": "clone.potato",
      "id": "1512054436",
      "name": "Potato Clone"
  },
  {
      "short": "seed.potato",
      "id": "-2084071424",
      "name": "Potato Seed"
  },
  {
      "short": "pumpkin",
      "id": "-567909622",
      "name": "Pumpkin"
  },
  {
      "short": "clone.pumpkin",
      "id": "1898094925",
      "name": "Pumpkin Plant Clone"
  },
  {
      "short": "radiationresisttea.pure",
      "id": "-33009419",
      "name": "Pure Anti-Rad Tea"
  },
  {
      "short": "healingtea.pure",
      "id": "-1677315902",
      "name": "Pure Healing Tea"
  },
  {
      "short": "seed.pumpkin",
      "id": "-1511285251",
      "name": "Pumpkin Seed"
  },
  {
      "short": "maxhealthtea.pure",
      "id": "1712261904",
      "name": "Pure Max Health Tea"
  },
  {
      "short": "radiationremovetea.pure",
      "id": "1905387657",
      "name": "Pure Rad. Removal Tea"
  },
  {
      "short": "oretea.pure",
      "id": "1729374708",
      "name": "Pure Ore Tea"
  },
  {
      "short": "radiationremovetea",
      "id": "-496584751",
      "name": "Rad. Removal Tea"
  },
  {
      "short": "woodtea.pure",
      "id": "-557539629",
      "name": "Pure Wood Tea"
  },
  {
      "short": "scraptea.pure",
      "id": "2024467711",
      "name": "Pure Scrap Tea"
  },
  {
      "short": "bearmeat",
      "id": "-1520560807",
      "name": "Raw Bear Meat"
  },
  {
      "short": "chicken.raw",
      "id": "-1440987069",
      "name": "Raw Chicken Breast"
  },
  {
      "short": "deermeat.raw",
      "id": "1422530437",
      "name": "Raw Deer Meat"
  },
  {
      "short": "fish.raw",
      "id": "989925924",
      "name": "Raw Fish"
  },
  {
      "short": "horsemeat.raw",
      "id": "-1130350864",
      "name": "Raw Horse Meat"
  },
  {
      "short": "humanmeat.raw",
      "id": "-1709878924",
      "name": "Raw Human Meat"
  },
  {
      "short": "meat.boar",
      "id": "621915341",
      "name": "Raw Pork"
  },
  {
      "short": "clone.red.berry",
      "id": "2133269020",
      "name": "Red Berry Clone"
  },
  {
      "short": "wolfmeat.raw",
      "id": "-395377963",
      "name": "Raw Wolf Meat"
  },
  {
      "short": "red.berry",
      "id": "1272194103",
      "name": "Red Berry"
  },
  {
      "short": "seed.red.berry",
      "id": "830839496",
      "name": "Red Berry Seed"
  },
  {
      "short": "apple.spoiled",
      "id": "352130972",
      "name": "Rotten Apple"
  },
  {
      "short": "fish.salmon",
      "id": "-851988960",
      "name": "Salmon"
  },
  {
      "short": "fish.sardine",
      "id": "-1654233406",
      "name": "Sardine"
  },
  {
      "short": "fish.smallshark",
      "id": "-1768880890",
      "name": "Small Shark"
  },
  {
      "short": "smallwaterbottle",
      "id": "-1039528932",
      "name": "Small Water Bottle"
  },
  {
      "short": "chicken.spoiled",
      "id": "-751151717",
      "name": "Spoiled Chicken"
  },
  {
      "short": "fish.troutsmall",
      "id": "-1878764039",
      "name": "Small Trout"
  },
  {
      "short": "humanmeat.spoiled",
      "id": "1272768630",
      "name": "Spoiled Human Meat"
  },
  {
      "short": "wolfmeat.spoiled",
      "id": "-1167031859",
      "name": "Spoiled Wolf Meat"
  },
  {
      "short": "bottle.vodka",
      "id": "755224797",
      "name": "Vodka Bottle"
  },
  {
      "short": "waterjug",
      "id": "-119235651",
      "name": "Water Jug"
  },
  {
      "short": "white.berry",
      "id": "854447607",
      "name": "White Berry"
  },
  {
      "short": "seed.white.berry",
      "id": "-992286106",
      "name": "White Berry Seed"
  },
  {
      "short": "clone.white.berry",
      "id": "1533551194",
      "name": "White Berry Clone"
  },
  {
      "short": "worm",
      "id": "1770475779",
      "name": "Worm"
  },
  {
      "short": "yellow.berry",
      "id": "1660145984",
      "name": "Yellow Berry"
  },
  {
      "short": "clone.yellow.berry",
      "id": "390728933",
      "name": "Yellow Berry Clone"
  },
  {
      "short": "fish.yellowperch",
      "id": "680234026",
      "name": "Yellow Perch"
  },
  {
      "short": "ammo.shotgun",
      "id": "-1685290200",
      "name": "12 Gauge Buckshot"
  },
  {
      "short": "ammo.shotgun.slug",
      "id": "-727717969",
      "name": "12 Gauge Slug"
  },
  {
      "short": "seed.yellow.berry",
      "id": "-520133715",
      "name": "Yellow Berry Seed"
  },
  {
      "short": "ammo.shotgun.fire",
      "id": "-1036635990",
      "name": "12 Gauge Incendiary Shell"
  },
  {
      "short": "ammo.grenadelauncher.he",
      "id": "349762871",
      "name": "40mm HE Grenade"
  },
  {
      "short": "ammo.grenadelauncher.buckshot",
      "id": "1055319033",
      "name": "40mm Shotgun Round"
  },
  {
      "short": "ammo.grenadelauncher.smoke",
      "id": "915408809",
      "name": "40mm Smoke Grenade"
  },
  {
      "short": "ammo.rifle",
      "id": "-1211166256",
      "name": "5.56 Rifle Ammo"
  },
  {
      "short": "arrow.bone",
      "id": "215754713",
      "name": "Bone Arrow"
  },
  {
      "short": "ammo.rifle.explosive",
      "id": "-1321651331",
      "name": "Explosive 5.56 Rifle Ammo"
  },
  {
      "short": "arrow.fire",
      "id": "14241751",
      "name": "Fire Arrow"
  },
  {
      "short": "ammo.rifle.hv",
      "id": "1712070256",
      "name": "HV 5.56 Rifle Ammo"
  },
  {
      "short": "ammo.handmade.shell",
      "id": "588596902",
      "name": "Handmade Shell"
  },
  {
      "short": "ammo.pistol.hv",
      "id": "-1691396643",
      "name": "HV Pistol Ammo"
  },
  {
      "short": "arrow.hv",
      "id": "-1023065463",
      "name": "High Velocity Arrow"
  },
  {
      "short": "ammo.rocket.hv",
      "id": "-1841918730",
      "name": "High Velocity Rocket"
  },
  {
      "short": "ammo.rifle.incendiary",
      "id": "605467368",
      "name": "Incendiary 5.56 Rifle Ammo"
  },
  {
      "short": "ammo.pistol.fire",
      "id": "51984655",
      "name": "Incendiary Pistol Bullet"
  },
  {
      "short": "ammo.rocket.fire",
      "id": "1638322904",
      "name": "Incendiary Rocket"
  },
  {
      "short": "ammo.rocket.mlrs",
      "id": "-1843426638",
      "name": "MLRS Rocket"
  },
  {
      "short": "ammo.nailgun.nails",
      "id": "-2097376851",
      "name": "Nailgun Nails"
  },
  {
      "short": "ammo.rocket.basic",
      "id": "-742865266",
      "name": "Rocket"
  },
  {
      "short": "ammo.pistol",
      "id": "785728077",
      "name": "Pistol Bullet"
  },
  {
      "short": "speargun.spear",
      "id": "-1800345240",
      "name": "Speargun Spear"
  },
  {
      "short": "ammo.rocket.sam",
      "id": "-384243979",
      "name": "SAM Ammo"
  },
  {
      "short": "submarine.torpedo.straight",
      "id": "-1671551935",
      "name": "Torpedo"
  },
  {
      "short": "ammo.rocket.smoke",
      "id": "-17123659",
      "name": "Smoke Rocket WIP!!!!"
  },
  {
      "short": "arrow.wooden",
      "id": "-1234735557",
      "name": "Wooden Arrow"
  },
  {
      "short": "flameturret",
      "id": "528668503",
      "name": "Flame Turret"
  },
  {
      "short": "trap.landmine",
      "id": "-1663759755",
      "name": "Land Mine"
  },
  {
      "short": "samsite",
      "id": "-1009359066",
      "name": "SAM Site"
  },
  {
      "short": "guntrap",
      "id": "352499047",
      "name": "Shotgun Trap"
  },
  {
      "short": "trap.bear",
      "id": "-582782051",
      "name": "Snap Trap"
  },
  {
      "short": "spikes.floor",
      "id": "-92759291",
      "name": "Wooden Floor Spikes"
  },
  {
      "short": "blueprintbase",
      "id": "-996920608",
      "name": "Blueprint"
  },
  {
      "short": "blue",
      "id": "-484206264",
      "name": "Blue Keycard"
  },
  {
      "short": "easter.bronzeegg",
      "id": "844440409",
      "name": "Bronze Egg"
  },
  {
      "short": "captainslog",
      "id": "1230691307",
      "name": "Captain's Log"
  },
  {
      "short": "car.key",
      "id": "946662961",
      "name": "Car Key"
  },
  {
      "short": "coffin.storage",
      "id": "573676040",
      "name": "Coffin"
  },
  {
      "short": "cursedcauldron",
      "id": "1242522330",
      "name": "Cursed Cauldron"
  },
  {
      "short": "xmas.decoration.baubels",
      "id": "-1667224349",
      "name": "Decorative Baubels"
  },
  {
      "short": "xmas.decoration.gingerbreadmen",
      "id": "1686524871",
      "name": "Decorative Gingerbread Men"
  },
  {
      "short": "xmas.decoration.pinecone",
      "id": "-129230242",
      "name": "Decorative Pinecones"
  },
  {
      "short": "xmas.decoration.candycanes",
      "id": "-209869746",
      "name": "Decorative Plastic Candy Canes"
  },
  {
      "short": "xmas.decoration.tinsel",
      "id": "2106561762",
      "name": "Decorative Tinsel"
  },
  {
      "short": "door.key",
      "id": "-1112793865",
      "name": "Door Key"
  },
  {
      "short": "easterbasket",
      "id": "1856217390",
      "name": "Egg Basket"
  },
  {
      "short": "fogmachine",
      "id": "-1973785141",
      "name": "Fogger-3000"
  },
  {
      "short": "giantcandycanedecor",
      "id": "-695124222",
      "name": "Giant Candy Decor"
  },
  {
      "short": "giantlollipops",
      "id": "282103175",
      "name": "Giant Lollipop Decor"
  },
  {
      "short": "easter.goldegg",
      "id": "-1002156085",
      "name": "Gold Egg"
  },
  {
      "short": "gravestone",
      "id": "809199956",
      "name": "Gravestone"
  },
  {
      "short": "wall.graveyard.fence",
      "id": "-1679267738",
      "name": "Graveyard Fence"
  },
  {
      "short": "halloween.candy",
      "id": "-888153050",
      "name": "Halloween Candy"
  },
  {
      "short": "green",
      "id": "37122747",
      "name": "Green Keycard"
  },
  {
      "short": "halloween.lootbag.large",
      "id": "479292118",
      "name": "Large Loot Bag"
  },
  {
      "short": "habrepair",
      "id": "-1759188988",
      "name": "Hab Repair"
  },
  {
      "short": "largecandles",
      "id": "-489848205",
      "name": "Large Candle Set"
  },
  {
      "short": "xmas.present.large",
      "id": "-1622660759",
      "name": "Large Present"
  },
  {
      "short": "minihelicopter.repair",
      "id": "1426574435",
      "name": "MC repair"
  },
  {
      "short": "halloween.lootbag.medium",
      "id": "1899610628",
      "name": "Medium Loot Bag"
  },
  {
      "short": "xmas.present.medium",
      "id": "756517185",
      "name": "Medium Present"
  },
  {
      "short": "note",
      "id": "1414245162",
      "name": "Note"
  },
  {
      "short": "easter.paintedeggs",
      "id": "-126305173",
      "name": "Painted Egg"
  },
  {
      "short": "photo",
      "id": "62577426",
      "name": "Photograph"
  },
  {
      "short": "red",
      "id": "-1880870149",
      "name": "Red Keycard"
  },
  {
      "short": "b",
      "id": "-173268132",
      "name": "Rustigé Egg - Blue"
  },
  {
      "short": "pumpkinbasket",
      "id": "1346158228",
      "name": "Pumpkin Bucket"
  },
  {
      "short": "d",
      "id": "-173268126",
      "name": "Rustigé Egg - Ivory"
  },
  {
      "short": "e",
      "id": "-173268125",
      "name": "Rustigé Egg - Green"
  },
  {
      "short": "c",
      "id": "-173268131",
      "name": "Rustigé Egg - Purple"
  },
  {
      "short": "a",
      "id": "-173268129",
      "name": "Rustigé Egg - Red"
  },
  {
      "short": "scraptransportheli.repair",
      "id": "-1884328185",
      "name": "ScrapTransportHeliRepair"
  },
  {
      "short": "sickle",
      "id": "-1368584029",
      "name": "Sickle"
  },
  {
      "short": "easter.silveregg",
      "id": "1757265204",
      "name": "Silver Egg"
  },
  {
      "short": "smallcandles",
      "id": "-2058362263",
      "name": "Small Candle Set"
  },
  {
      "short": "halloween.lootbag.small",
      "id": "1319617282",
      "name": "Small Loot Bag"
  },
  {
      "short": "xmas.present.small",
      "id": "-722241321",
      "name": "Small Present"
  },
  {
      "short": "spiderweb",
      "id": "882559853",
      "name": "Spider Webs"
  },
  {
      "short": "snowmachine",
      "id": "1358643074",
      "name": "Snow Machine"
  },
  {
      "short": "spookyspeaker",
      "id": "1885488976",
      "name": "Spooky Speaker"
  },
  {
      "short": "xmas.decoration.lights",
      "id": "1723747470",
      "name": "Tree Lights"
  },
  {
      "short": "strobelight",
      "id": "2104517339",
      "name": "Strobe Light"
  },
  {
      "short": "xmas.decoration.star",
      "id": "-1331212963",
      "name": "Star Tree Topper"
  },
  {
      "short": "woodcross",
      "id": "699075597",
      "name": "Wooden Cross"
  },
  {
      "short": "vehicle.1mod.cockpit.armored",
      "id": "1874610722",
      "name": "Armored Cockpit Vehicle Module"
  },
  {
      "short": "vehicle.1mod.passengers.armored",
      "id": "-1615281216",
      "name": "Armored Passenger Vehicle Module"
  },
  {
      "short": "bleach",
      "id": "1553078977",
      "name": "Bleach"
  },
  {
      "short": "vehicle.2mod.camper",
      "id": "-1040518150",
      "name": "Camper Vehicle Module"
  },
  {
      "short": "vehicle.1mod.cockpit",
      "id": "-1501451746",
      "name": "Cockpit Vehicle Module"
  },
  {
      "short": "ducttape",
      "id": "1401987718",
      "name": "Duct Tape"
  },
  {
      "short": "vehicle.1mod.cockpit.with.engine",
      "id": "170758448",
      "name": "Cockpit With Engine Vehicle Module"
  },
  {
      "short": "vehicle.1mod.flatbed",
      "id": "-1880231361",
      "name": "Flatbed Vehicle Module"
  },
  {
      "short": "fuse",
      "id": "-629028935",
      "name": "Electric Fuse"
  },
  {
      "short": "propanetank",
      "id": "-1673693549",
      "name": "Empty Propane Tank"
  },
  {
      "short": "vehicle.1mod.engine",
      "id": "1559779253",
      "name": "Engine Vehicle Module"
  },
  {
      "short": "vehicle.2mod.fuel.tank",
      "id": "1186655046",
      "name": "Fuel Tank Vehicle Module"
  },
  {
      "short": "gears",
      "id": "479143914",
      "name": "Gears"
  },
  {
      "short": "glue",
      "id": "-1899491405",
      "name": "Glue"
  },
  {
      "short": "carburetor3",
      "id": "656371026",
      "name": "High Quality Carburetor"
  },
  {
      "short": "piston3",
      "id": "1883981800",
      "name": "High Quality Pistons"
  },
  {
      "short": "crankshaft3",
      "id": "1158340332",
      "name": "High Quality Crankshaft"
  },
  {
      "short": "sparkplug3",
      "id": "1072924620",
      "name": "High Quality Spark Plugs"
  },
  {
      "short": "valve3",
      "id": "-1802083073",
      "name": "High Quality Valves"
  },
  {
      "short": "carburetor1",
      "id": "656371028",
      "name": "Low Quality Carburetor"
  },
  {
      "short": "crankshaft1",
      "id": "1158340334",
      "name": "Low Quality Crankshaft"
  },
  {
      "short": "vehicle.2mod.flatbed",
      "id": "-1693832478",
      "name": "Large Flatbed Vehicle Module"
  },
  {
      "short": "piston1",
      "id": "1883981798",
      "name": "Low Quality Pistons"
  },
  {
      "short": "sparkplug1",
      "id": "-89874794",
      "name": "Low Quality Spark Plugs"
  },
  {
      "short": "valve1",
      "id": "1330084809",
      "name": "Low Quality Valves"
  },
  {
      "short": "aiming.module.mlrs",
      "id": "343045591",
      "name": "MLRS Aiming Module"
  },
  {
      "short": "carburetor2",
      "id": "656371027",
      "name": "Medium Quality Carburetor"
  },
  {
      "short": "crankshaft2",
      "id": "1158340331",
      "name": "Medium Quality Crankshaft"
  },
  {
      "short": "piston2",
      "id": "1883981801",
      "name": "Medium Quality Pistons"
  },
  {
      "short": "sparkplug2",
      "id": "-493159321",
      "name": "Medium Quality Spark Plugs"
  },
  {
      "short": "valve2",
      "id": "926800282",
      "name": "Medium Quality Valves"
  },
  {
      "short": "metalpipe",
      "id": "95950017",
      "name": "Metal Pipe"
  },
  {
      "short": "metalblade",
      "id": "1882709339",
      "name": "Metal Blade"
  },
  {
      "short": "metalspring",
      "id": "-1021495308",
      "name": "Metal Spring"
  },
  {
      "short": "vehicle.2mod.passengers",
      "id": "895374329",
      "name": "Passenger Vehicle Module"
  },
  {
      "short": "vehicle.1mod.rear.seats",
      "id": "1376065505",
      "name": "Rear Seats Vehicle Module"
  },
  {
      "short": "riflebody",
      "id": "176787552",
      "name": "Rifle Body"
  },
  {
      "short": "roadsigns",
      "id": "1199391518",
      "name": "Road Signs"
  },
  {
      "short": "rope",
      "id": "1414245522",
      "name": "Rope"
  },
  {
      "short": "semibody",
      "id": "573926264",
      "name": "Semi Automatic Body"
  },
  {
      "short": "smgbody",
      "id": "1230323789",
      "name": "SMG Body"
  },
  {
      "short": "sewingkit",
      "id": "1234880403",
      "name": "Sewing Kit"
  },
  {
      "short": "sheetmetal",
      "id": "-1994909036",
      "name": "Sheet Metal"
  },
  {
      "short": "sticks",
      "id": "642482233",
      "name": "Sticks"
  },
  {
      "short": "vehicle.1mod.storage",
      "id": "268565518",
      "name": "Storage Vehicle Module"
  },
  {
      "short": "tarp",
      "id": "2019042823",
      "name": "Tarp"
  },
  {
      "short": "vehicle.1mod.taxi",
      "id": "-626174997",
      "name": "Taxi Vehicle Module"
  },
  {
      "short": "techparts",
      "id": "73681876",
      "name": "Tech Trash"
  },
  {
      "short": "electric.andswitch",
      "id": "1171735914",
      "name": "AND Switch"
  },
  {
      "short": "electric.audioalarm",
      "id": "2100007442",
      "name": "Audio Alarm"
  },
  {
      "short": "autoturret",
      "id": "-2139580305",
      "name": "Auto Turret"
  },
  {
      "short": "electric.blocker",
      "id": "-690968985",
      "name": "Blocker"
  },
  {
      "short": "electric.button",
      "id": "-1778897469",
      "name": "Button"
  },
  {
      "short": "electric.cabletunnel",
      "id": "1835946060",
      "name": "Cable Tunnel"
  },
  {
      "short": "computerstation",
      "id": "-1588628467",
      "name": "Computer Station"
  },
  {
      "short": "ceilinglight",
      "id": "1142993169",
      "name": "Ceiling Light"
  },
  {
      "short": "electric.counter",
      "id": "-216999575",
      "name": "Counter"
  },
  {
      "short": "electric.doorcontroller",
      "id": "-502177121",
      "name": "Door Controller"
  },
  {
      "short": "xmas.lightstring.advanced",
      "id": "-151387974",
      "name": "Deluxe Christmas Lights"
  },
  {
      "short": "electrical.branch",
      "id": "-1448252298",
      "name": "Electrical Branch"
  },
  {
      "short": "elevator",
      "id": "1177596584",
      "name": "Elevator"
  },
  {
      "short": "electric.heater",
      "id": "-784870360",
      "name": "Electric Heater"
  },
  {
      "short": "electric.flasherlight",
      "id": "-939424778",
      "name": "Flasher Light"
  },
  {
      "short": "fluid.combiner",
      "id": "-265292885",
      "name": "Fluid Combiner"
  },
  {
      "short": "fluid.splitter",
      "id": "-1166712463",
      "name": "Fluid Splitter"
  },
  {
      "short": "fluid.switch",
      "id": "443432036",
      "name": "Fluid Switch & Pump"
  },
  {
      "short": "industrial.wall.light.green",
      "id": "1268178466",
      "name": "Green Industrial Wall Light"
  },
  {
      "short": "electric.hbhfsensor",
      "id": "-1507239837",
      "name": "HBHF Sensor"
  },
  {
      "short": "electric.igniter",
      "id": "-44876289",
      "name": "Igniter"
  },
  {
      "short": "hosetool",
      "id": "363163265",
      "name": "Hose Tool"
  },
  {
      "short": "industrial.wall.light",
      "id": "1623701499",
      "name": "Industrial Wall Light"
  },
  {
      "short": "sign.neon.xl.animated",
      "id": "1643667218",
      "name": "Large Animated Neon Sign"
  },
  {
      "short": "sign.neon.xl",
      "id": "866332017",
      "name": "Large Neon Sign"
  },
  {
      "short": "electric.battery.rechargable.large",
      "id": "553270375",
      "name": "Large Rechargeable Battery"
  },
  {
      "short": "electric.solarpanel.large",
      "id": "2090395347",
      "name": "Large Solar Panel"
  },
  {
      "short": "electric.laserdetector",
      "id": "-798293154",
      "name": "Laser Detector"
  },
  {
      "short": "sign.neon.125x215.animated",
      "id": "42535890",
      "name": "Medium Animated Neon Sign"
  },
  {
      "short": "sign.neon.125x215",
      "id": "-1423304443",
      "name": "Medium Neon Sign"
  },
  {
      "short": "electric.battery.rechargable.medium",
      "id": "2023888403",
      "name": "Medium Rechargeable Battery"
  },
  {
      "short": "modularcarlift",
      "id": "1696050067",
      "name": "Modular Car Lift"
  },
  {
      "short": "electrical.memorycell",
      "id": "-746647361",
      "name": "Memory Cell"
  },
  {
      "short": "powered.water.purifier",
      "id": "-365097295",
      "name": "Powered Water Purifier"
  },
  {
      "short": "electric.orswitch",
      "id": "-1286302544",
      "name": "OR Switch"
  },
  {
      "short": "pager",
      "id": "-566907190",
      "name": "RF Pager"
  },
  {
      "short": "electric.random.switch",
      "id": "492357192",
      "name": "RAND Switch"
  },
  {
      "short": "electric.rf.broadcaster",
      "id": "-1044468317",
      "name": "RF Broadcaster"
  },
  {
      "short": "electric.pressurepad",
      "id": "-2049214035",
      "name": "Pressure Pad"
  },
  {
      "short": "electrical.combiner",
      "id": "-458565393",
      "name": "Root Combiner"
  },
  {
      "short": "target.reactive",
      "id": "-1736356576",
      "name": "Reactive Target"
  },
  {
      "short": "industrial.wall.light.red",
      "id": "-1160621614",
      "name": "Red Industrial Wall Light"
  },
  {
      "short": "electric.rf.receiver",
      "id": "888415708",
      "name": "RF Receiver"
  },
  {
      "short": "searchlight",
      "id": "2087678962",
      "name": "Search Light"
  },
  {
      "short": "electric.sirenlight",
      "id": "762289806",
      "name": "Siren Light"
  },
  {
      "short": "electric.fuelgenerator.small",
      "id": "1849887541",
      "name": "Small Generator"
  },
  {
      "short": "electric.simplelight",
      "id": "-282113991",
      "name": "Simple Light"
  },
  {
      "short": "electric.battery.rechargable.small",
      "id": "-692338819",
      "name": "Small Rechargeable Battery"
  },
  {
      "short": "sign.neon.125x125",
      "id": "1305578813",
      "name": "Small Neon Sign"
  },
  {
      "short": "smart.switch",
      "id": "988652725",
      "name": "Smart Switch"
  },
  {
      "short": "electric.sprinkler",
      "id": "-781014061",
      "name": "Sprinkler"
  },
  {
      "short": "smart.alarm",
      "id": "-695978112",
      "name": "Smart Alarm"
  },
  {
      "short": "electric.splitter",
      "id": "-563624462",
      "name": "Splitter"
  },
  {
      "short": "storage.monitor",
      "id": "1149964039",
      "name": "Storage Monitor"
  },
  {
      "short": "electric.switch",
      "id": "1951603367",
      "name": "Switch"
  },
  {
      "short": "electric.teslacoil",
      "id": "1371909803",
      "name": "Tesla Coil"
  },
  {
      "short": "electric.generator.small",
      "id": "-295829489",
      "name": "Test Generator"
  },
  {
      "short": "electric.timer",
      "id": "665332906",
      "name": "Timer"
  },
  {
      "short": "waterpump",
      "id": "-1284169891",
      "name": "Water Pump"
  },
  {
      "short": "generator.wind.scrap",
      "id": "-1819763926",
      "name": "Wind Turbine"
  },
  {
      "short": "beachchair",
      "id": "-321431890",
      "name": "Beach Chair"
  },
  {
      "short": "electric.xorswitch",
      "id": "1293102274",
      "name": "XOR Switch"
  },
  {
      "short": "fun.guitar",
      "id": "-2124352573",
      "name": "Acoustic Guitar"
  },
  {
      "short": "abovegroundpool",
      "id": "1840570710",
      "name": "Above Ground Pool"
  },
  {
      "short": "wiretool",
      "id": "-144417939",
      "name": "Wire Tool"
  },
  {
      "short": "beachparasol",
      "id": "-1621539785",
      "name": "Beach Parasol"
  },
  {
      "short": "beachtable",
      "id": "657352755",
      "name": "Beach Table"
  },
  {
      "short": "beachtowel",
      "id": "-8312704",
      "name": "Beach Towel"
  },
  {
      "short": "firework.boomer.blue",
      "id": "1744298439",
      "name": "Blue Boomer"
  },
  {
      "short": "firework.romancandle.blue",
      "id": "-515830359",
      "name": "Blue Roman Candle"
  },
  {
      "short": "boombox",
      "id": "-1113501606",
      "name": "Boom Box"
  },
  {
      "short": "boogieboard",
      "id": "-1478094705",
      "name": "Boogie Board"
  },
  {
      "short": "cassette",
      "id": "476066818",
      "name": "Cassette - Long"
  },
  {
      "short": "fun.casetterecorder",
      "id": "-1530414568",
      "name": "Cassette Recorder"
  },
  {
      "short": "firework.boomer.champagne",
      "id": "1324203999",
      "name": "Champagne Boomer"
  },
  {
      "short": "fun.tambourine",
      "id": "-1379036069",
      "name": "Canbourine"
  },
  {
      "short": "cassette.medium",
      "id": "-912398867",
      "name": "Cassette - Medium"
  },
  {
      "short": "cassette.short",
      "id": "1523403414",
      "name": "Cassette - Short"
  },
  {
      "short": "connected.speaker",
      "id": "968421290",
      "name": "Connected Speaker"
  },
  {
      "short": "fun.cowbell",
      "id": "-1049881973",
      "name": "Cowbell"
  },
  {
      "short": "discoball",
      "id": "1895235349",
      "name": "Disco Ball"
  },
  {
      "short": "discofloor",
      "id": "286648290",
      "name": "Disco Floor"
  },
  {
      "short": "lunar.firecrackers",
      "id": "-1961560162",
      "name": "Firecracker String"
  },
  {
      "short": "firework.boomer.green",
      "id": "-656349006",
      "name": "Green Boomer"
  },
  {
      "short": "drumkit",
      "id": "-1330640246",
      "name": "Junkyard Drum Kit"
  },
  {
      "short": "firework.romancandle.green",
      "id": "-1306288356",
      "name": "Green Roman Candle"
  },
  {
      "short": "fun.jerrycanguitar",
      "id": "-979951147",
      "name": "Jerry Can Guitar"
  },
  {
      "short": "innertube",
      "id": "-697981032",
      "name": "Inner Tube"
  },
  {
      "short": "megaphone",
      "id": "-583379016",
      "name": "Megaphone"
  },
  {
      "short": "laserlight",
      "id": "853471967",
      "name": "Laser Light"
  },
  {
      "short": "firework.boomer.orange",
      "id": "-7270019",
      "name": "Orange Boomer"
  },
  {
      "short": "mobilephone",
      "id": "-20045316",
      "name": "Mobile Phone"
  },
  {
      "short": "newyeargong",
      "id": "-961457160",
      "name": "New Year Gong"
  },
  {
      "short": "microphonestand",
      "id": "39600618",
      "name": "Microphone Stand"
  },
  {
      "short": "fun.flute",
      "id": "-2040817543",
      "name": "Pan Flute"
  },
  {
      "short": "fun.boomboxportable",
      "id": "576509618",
      "name": "Portable Boom Box"
  },
  {
      "short": "paddlingpool",
      "id": "-733625651",
      "name": "Paddling Pool"
  },
  {
      "short": "fun.trumpet",
      "id": "273172220",
      "name": "Plumber's Trumpet"
  },
  {
      "short": "firework.boomer.red",
      "id": "-1553999294",
      "name": "Red Boomer"
  },
  {
      "short": "firework.romancandle.red",
      "id": "-1486461488",
      "name": "Red Roman Candle"
  },
  {
      "short": "firework.volcano.red",
      "id": "-454370658",
      "name": "Red Volcano Firework"
  },
  {
      "short": "fun.bass",
      "id": "-2107018088",
      "name": "Shovel Bass"
  },
  {
      "short": "skullspikes",
      "id": "-1073015016",
      "name": "Skull Spikes"
  },
  {
      "short": "skull.trophy",
      "id": "-769647921",
      "name": "Skull Trophy"
  },
  {
      "short": "sled.xmas",
      "id": "-135252633",
      "name": "Sled"
  },
  {
      "short": "fun.tuba",
      "id": "1784406797",
      "name": "Sousaphone"
  },
  {
      "short": "telephone",
      "id": "1234878710",
      "name": "Telephone"
  },
  {
      "short": "soundlight",
      "id": "-343857907",
      "name": "Sound Light"
  },
  {
      "short": "firework.boomer.violet",
      "id": "-280223496",
      "name": "Violet Boomer"
  },
  {
      "short": "firework.romancandle.violet",
      "id": "-99886070",
      "name": "Violet Roman Candle"
  },
  {
      "short": "firework.volcano.violet",
      "id": "-1538109120",
      "name": "Violet Volcano Firework"
  },
  {
      "short": "piano",
      "id": "1272430949",
      "name": "Wheelbarrow Piano"
  },
  {
      "short": "firework.volcano",
      "id": "261913429",
      "name": "White Volcano Firework"
  },
  {
      "short": "wrappedgift",
      "id": "204970153",
      "name": "Wrapped Gift"
  },
  {
      "short": "wrappingpaper",
      "id": "1094293920",
      "name": "Wrapping Paper"
  },
  {
      "short": "xylophone",
      "id": "-211235948",
      "name": "Xylobone"
  },
  {
      "short": "spraycan",
      "id": "-596876839",
      "name": "Spraycan"
  },
  {
      "short": "nomad",
      "id": "491263800",
      "name": "Nomad Outfit"
  },
  {
      "short": "artichazmat",
      "id": "-470439097",
      "name": "Artic Hazmat"
  }
];

export default rustItems;